(() => {
  if (window.holidayHomeCarousel) return;
  window.holidayHomeCarousel = true;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // A card cut off by the track's edge is "peeking". Rooted on the track, so a card
  // below the fold isn't counted — only the carousel edge clips it.
  const watchPeek = (track) => {
    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        entry.target.classList.toggle('is-peeking', entry.isIntersecting && entry.intersectionRatio < 0.99);
      });
    }, { root: track, threshold: [0, 0.25, 0.5, 0.75, 0.99, 1] });
    track.querySelectorAll('.holiday-bs-card').forEach((card) => observer.observe(card));
  };

  const initCarousel = (root) => {
    if (root.dataset.holidayBsReady) return;
    const track = root.querySelector('[data-holiday-bs-track]');
    if (!track) return;
    root.dataset.holidayBsReady = 'true';
    watchPeek(track);

    const prev = root.querySelector('[data-holiday-bs-prev]');
    const next = root.querySelector('[data-holiday-bs-next]');
    if (!prev || !next) return;

    const viewport = track.parentElement;

    const step = () => {
      const card = track.firstElementChild;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      return card ? card.getBoundingClientRect().width + gap : track.clientWidth;
    };

    const update = () => {
      const max = track.scrollWidth - track.clientWidth;
      prev.disabled = track.scrollLeft <= 1;
      next.disabled = track.scrollLeft >= max - 1;

      // Centre the arrows on the product image, not the whole card.
      const media = track.querySelector('.product-card-2026__image-wrap');
      if (media) {
        const top = media.getBoundingClientRect().top - viewport.getBoundingClientRect().top;
        root.style.setProperty('--holiday-bs-arrow-top', `${top + media.offsetHeight / 2}px`);
      }
    };

    const go = (direction) => {
      track.scrollBy({ left: direction * step(), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => go(-1));
    next.addEventListener('click', () => go(1));
    track.addEventListener('scroll', update, { passive: true });
    new ResizeObserver(update).observe(track);
    update();
  };

  const boot = (scope = document) => {
    scope.querySelectorAll('.holiday-bestsellers').forEach(initCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => boot());
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', (event) => boot(event.target));
})();
